import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml, SafeScript, SafeStyle} from '@angular/platform-browser';

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {

  }

  public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript {
    switch (type) {
      case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
      default: throw new Error(`Invalid safe type specified: ${type}`);
    }
  }

}
